// extracted by mini-css-extract-plugin
module.exports = {"container":"LegendComponent_container__10ueu","header":"LegendComponent_header__3-q74","content":"LegendComponent_content__2ov_d"};